/* eslint-disable no-nested-ternary */
// TODO: refactor this module to meet 'no-nested-ternary' rule
import _ from 'lodash';
import moment from 'moment';
import Multiselect from 'react-bootstrap-multiselect';
import React, { Component } from 'react';
import update from 'immutability-helper';
import {
  DOCTOR_ID,
  ASSISTANT_ID,
  NURSE_ID,
} from '../../constants/RoleConstants';
import Select from '../shared/Select';
import i18n from '../../config/i18n';

const styles = {
  wrapper: {
    overflowX: 'auto',
  },
  thead: {
    backgroundColor: '#607484',
    color: '#FFF',
  },
  th: {
    fontSize: 23,
  },
  edit: {
    float: 'right',
  },
  greyOut: {
    opacity: 0.6,
  },
};

// NOTE: return BMI from height (cm) and weight (kg)
function getBMI({ height, weight }) {
  return Math.round((weight * 100) / ((height / 100) ** 2)) / 100.0;
}

class PatientData extends Component {
  constructor(props) {
    super(props);
    const { patient: { patientDetail: { medicalInfo: medicalInfoSrc } } } = this.props;

    // medicalInfoSrc can be null, so we cannot use default value in destruction
    const medicalInfo = medicalInfoSrc || {};

    this.state = {
      isEditing: false,
      patientData: {
        consciousness: medicalInfo.consciousness || '',
        specialCare: medicalInfo.specialCare || '[]',
        dietary: medicalInfo.dietary || '',
        weight: medicalInfo.weight || '',
        height: medicalInfo.height || '',
        bmi: medicalInfo.bmi || '',
        bloodPressure: medicalInfo.bloodPressure || '',
        bloodGlucose: medicalInfo.bloodGlucose || '',
        activityLevel: medicalInfo.activityLevel || '',
        medicationHistory: medicalInfo.medicationHistory || '',
        medicalHistory: medicalInfo.medicalHistory || '[]',
      },
    };
  }

  setInputsToDefaultValues = () => {
    const { patient: { patientDetail: { medicalInfo: medicalInfoSrc } } } = this.props;
    const medicalInfo = medicalInfoSrc || {};
    this.setState({
      patientData: {
        consciousness: medicalInfo.consciousness || '',
        specialCare: medicalInfo.specialCare || '[]',
        dietary: medicalInfo.dietary || '',
        weight: medicalInfo.weight || '',
        height: medicalInfo.height || '',
        bmi: medicalInfo.bmi || '',
        bloodPressure: medicalInfo.bloodPressure || '',
        bloodGlucose: medicalInfo.bloodGlucose || '',
        activityLevel: medicalInfo.activityLevel || '',
        medicationHistory: medicalInfo.medicationHistory || '',
        medicalHistory: medicalInfo.medicalHistory || '[]',
      },
    });
  }

  handleConsciousnessChange = (value) => {
    const newPatientData = update(this.state.patientData,
      { consciousness: { $set: value } });
    this.setState({ patientData: newPatientData });
  };

  handleDietaryChange = (value) => {
    const newPatientData = update(this.state.patientData,
      { dietary: { $set: value } });
    this.setState({ patientData: newPatientData });
  };

  handleWeightChange = (e) => {
    const updatedWeight = e.target.value;
    const newPatientData = update(this.state.patientData, {
      weight: {
        $set: updatedWeight,
      },
      bmi: {
        $set: getBMI({ height: this.state.patientData.height, weight: updatedWeight }),
      },
    });
    this.setState({ patientData: newPatientData });
  };

  handleHeightChange = (e) => {
    const updatedHeight = e.target.value;
    const newPatientData = update(this.state.patientData, {
      height: {
        $set: updatedHeight,
      },
      bmi: {
        $set: getBMI({
          height: updatedHeight,
          weight: this.state.patientData.weight,
        }),
      },
    });
    this.setState({ patientData: newPatientData });
  };

  handleBMIChange = (e) => {
    const newPatientData = update(this.state.patientData,
      { bmi: { $set: e.target.value } });
    this.setState({ patientData: newPatientData });
  };

  handleBloodPressureChange = (e) => {
    const newPatientData = update(this.state.patientData,
      { bloodPressure: { $set: e.target.value } });
    this.setState({ patientData: newPatientData });
  };

  handleBloodGlucoseChange = (e) => {
    const newPatientData = update(this.state.patientData,
      { bloodGlucose: { $set: e.target.value } });
    this.setState({ patientData: newPatientData });
  };

  handleActivityLevelChange = (value) => {
    const newPatientData = update(this.state.patientData,
      { activityLevel: { $set: value } });
    this.setState({ patientData: newPatientData });
  };

  handleMedicationHistoryChange = (e) => {
    const newPatientData = update(this.state.patientData,
      { medicationHistory: { $set: e.target.value } });
    this.setState({ patientData: newPatientData });
  };

  handleSpecialCareChange = (e) => {
    const { metadata: { data: { specialCare: specialCareMetadata } } } = this.props;
    const {
      patientData,
      patientData: { specialCare: specialCareString },
    } = this.state;
    const specialCare = this.processMultiSelect(specialCareString, e, specialCareMetadata);
    const newPatientData = update(patientData,
      { specialCare: { $set: JSON.stringify(specialCare) } });
    this.setState({ patientData: newPatientData });
  };

  handleMedicalHistoryChange = (e) => {
    const { metadata: { data: { medicalHistory: medicalHistoryMetadata } } } = this.props;
    const {
      patientData,
      patientData: { medicalHistory: medicalHistoryString },
    } = this.state;
    const medicalHistory = this.processMultiSelect(medicalHistoryString, e, medicalHistoryMetadata);
    const newPatientData = update(patientData,
      { medicalHistory: { $set: JSON.stringify(medicalHistory) } });
    this.setState({ patientData: newPatientData });
  };

  canEditPatientData = () => {
    const { user: { profile: { roleId } } } = this.props;
    return [DOCTOR_ID, ASSISTANT_ID, NURSE_ID].indexOf(roleId) > -1;
  };

  updateData = async () => {
    const {
      actions: { updatePatientData },
      medicalRecordId,
    } = this.props;
    const {
      patientData,
      isEditing,
    } = this.state;

    const result = await updatePatientData(
      { medicalInfo: patientData },
      medicalRecordId);
    if (result === true) {
      this.setState({ isEditing: !isEditing });
    } else {
      this.setInputsToDefaultValues();
    }
  };

  edit = () => {
    this.setState({ isEditing: !this.state.isEditing });
  };

  cancel = () => {
    this.setState({ isEditing: false });
    this.setInputsToDefaultValues();
  };

  /**
   * Currently we use label string to check if 'None' is selected.
   * If the selection logic becomes complex in the future, we should
   * refactor this to use selection rule as we used in fpp survey.
   */
  processMultiSelect = (selectedListString, targetElement, optionMetadata) => {
    let selectedList = JSON.parse(selectedListString);
    const targetValue = targetElement.val();
    const targetIdx = selectedList.indexOf(targetValue);
    if (targetIdx !== -1) {
      // Remove target option if pre-selected.
      selectedList.splice(targetIdx, 1);
    } else if (targetElement.attr('label') === 'None') {
      // Clear other options if the target option is 'None'
      selectedList = [targetValue];
    } else {
      // Remove 'None' option if it is pre-selected
      const noneItem = optionMetadata.find(data => data.name === 'None');
      const noneItemIdx = selectedList.indexOf(noneItem.id.toString());
      if (noneItemIdx !== -1) selectedList.splice(noneItemIdx, 1);

      selectedList.push(targetValue);
    }
    return selectedList;
  };

  render() {
    const {
      metadata,
      patient,
    } = this.props;
    const {
      patientData,
      isEditing,
    } = this.state;
    const consciousness = _.filter(metadata.data.consciousness,
      { id: parseInt(patientData.consciousness, 10) });
    const dietary = _.filter(metadata.data.dietary,
      { id: parseInt(patientData.dietary, 10) });
    const activityLevel = _.filter(metadata.data.activityLevel,
      { id: parseInt(patientData.activityLevel, 10) });

    const selectedMedicalHistoryIds = JSON.parse(patientData.medicalHistory)
      .map(id => parseInt(id, 10));
    const medicalHistorys = _.filter(metadata.data.medicalHistory,
      data => selectedMedicalHistoryIds.indexOf(data.id) !== -1);
    const medicalHistoryForMultiData = _.map(metadata.data.medicalHistory, (data) => {
      if (selectedMedicalHistoryIds.indexOf(data.id) !== -1) {
        return { value: data.id, label: data.name, selected: true };
      }
      return { value: data.id, label: data.name };
    });

    const selectedSpecialCareIds = JSON.parse(patientData.specialCare)
      .map(id => parseInt(id, 10));
    const specialCares = _.filter(metadata.data.specialCare,
      data => selectedSpecialCareIds.indexOf(data.id) !== -1);
    const specialCareForMultiData = _.map(metadata.data.specialCare, (data) => {
      if (selectedSpecialCareIds.indexOf(data.id) !== -1) {
        return { value: data.id, label: data.name, selected: true };
      }
      return { value: data.id, label: data.name };
    });

    const {
      wrapper,
      thead,
      th,
      edit,
      greyOut,
    } = styles;

    return (
      <div style={wrapper}>
        <table
          className="table table-responsive table-bordered patient"
          style={patient.isPatientDataUpdating ? greyOut : {}}
        >
          <thead style={thead}>
            <tr>
              <th
                colSpan="6"
                style={th}
              >
                {i18n.t('patientData')}
                <span style={edit}>
                  {
                    this.canEditPatientData()
                      ? (
                        isEditing
                          ? (
                            <div className="btn-group">
                              <button
                                className="btn btn-success btn-sm"
                                onClick={this.updateData}
                              >
                                {i18n.t('update')}
                              </button>
                              <button
                                className="btn btn-default btn-sm"
                                onClick={this.cancel}
                              >
                                {i18n.t('cancel')}
                              </button>
                            </div>
                          )
                          : (
                            <div>
                              <div className="btn-group">
                                <button
                                  className="btn btn-info btn-sm"
                                  onClick={this.edit}
                                >
                                  {i18n.t('edit')}
                                </button>
                              </div>
                            </div>
                          )
                      )
                      : null
                  }
                </span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>
                {i18n.t('assessmentTime')}
              </th>
              <td colSpan="2">
                {moment(patient.patientDetail.created).format('YYYY-MM-DD hh:mm a')}
              </td>
              <th>
                {i18n.t('consciousness')}
              </th>
              <td colSpan="2">
                {
                  isEditing ?
                    <Select
                      className="form-control input-sm"
                      data={metadata.data.consciousness || []}
                      onChange={this.handleConsciousnessChange}
                      value={patientData.consciousness}
                    /> : consciousness[0] ? consciousness[0].name : ''
                }
              </td>
            </tr>
            <tr>
              <th>
                {i18n.t('medicationHistory')}
              </th>
              <td colSpan="2">
                {
                  isEditing ?
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientData.medicationHistory}
                      onChange={this.handleMedicationHistoryChange}
                    /> : patientData.medicationHistory
                }
              </td>
              <th>
                {i18n.t('dietary')}
              </th>
              <td colSpan="2">
                {
                  isEditing ?
                    <Select
                      className="form-control input-sm"
                      data={metadata.data.dietary || []}
                      onChange={this.handleDietaryChange}
                      value={patientData.dietary}
                    /> : dietary[0] ? dietary[0].name : ''
                }
              </td>
            </tr>
            <tr>
              <th width="20%">
                {i18n.t('weight_kg')}
              </th>
              <td width="13%">
                {
                  isEditing ?
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientData.weight}
                      onChange={this.handleWeightChange}
                    /> : patientData.weight
                }
              </td>
              <th width="20%">
                {i18n.t('height_cm')}
              </th>
              <td width="13%">
                {
                  isEditing ?
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientData.height}
                      onChange={this.handleHeightChange}
                    /> : patientData.height
                }
              </td>
              <th width="20%">
                {i18n.t('bmi')}
              </th>
              <td width="13%">
                {patientData.bmi}
              </td>
            </tr>
            <tr>
              <th>
                {i18n.t('bloodPressure_mm_hg')}
              </th>
              <td>
                {
                  isEditing ?
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientData.bloodPressure}
                      onChange={this.handleBloodPressureChange}
                    /> : patientData.bloodPressure
                }
              </td>
              <th>
                {i18n.t('bloodGlucose_mmol_l_ac_pc')}
              </th>
              <td>
                {
                  isEditing ?
                    <input
                      type="text"
                      className="form-control input-sm"
                      value={patientData.bloodGlucose}
                      onChange={this.handleBloodGlucoseChange}
                    /> : patientData.bloodGlucose
                }
              </td>
              <th>
                {i18n.t('activityLevel')}
              </th>
              <td>
                {
                  isEditing ?
                    <Select
                      className="form-control input-sm"
                      data={metadata.data.activityLevel || []}
                      onChange={this.handleActivityLevelChange}
                      value={patientData.activityLevel}
                    /> : activityLevel[0] ? activityLevel[0].name : ''
                }
              </td>
            </tr>
            <tr>
              <th>
                {i18n.t('specialCare')}
              </th>
              <td colSpan="7">
                {
                  isEditing
                    ? (
                      <div><Multiselect
                        data={specialCareForMultiData}
                        multiple
                        buttonWidth="100%"
                        numberDisplayed={7}
                        onChange={this.handleSpecialCareChange}
                        buttonClass="btn btn-sm btn-default"
                      /></div>
                    )
                    : (
                      specialCares
                        ? specialCares.map(data => data.name).join(', ')
                        : ''
                    )
                }
              </td>
            </tr>
            <tr>
              <th>
                {i18n.t('medicalHistory')}
              </th>
              <td colSpan="7">
                {
                  isEditing
                    ? (
                      <div><Multiselect
                        data={medicalHistoryForMultiData}
                        multiple
                        buttonWidth="100%"
                        numberDisplayed={7}
                        onChange={this.handleMedicalHistoryChange}
                        buttonClass="btn btn-sm btn-default"
                      /></div>
                    )
                    : (
                      medicalHistorys
                        ? medicalHistorys.map(data => data.name).join(', ')
                        : ''
                    )
                }
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  }
}

export default PatientData;



// WEBPACK FOOTER //
// ./src/components/patient/PatientData.js